import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
//import './style.scss'
import axios from 'axios';
import NPPanel from '../NPPanel';
import NPTreeMenu from '../NPTreeMenu'
import DocumentsPresentation from './DocumentsPresentation'
import LoadingSpinner from '../LoadingSpinner';
import constants from '../util/constants';
import DataSheets from './DatasheetsPresentation/index'
import { hasGrant } from '../util/grantHelper';
import * as Grants from '../util/grants';

const { API_BASE_URL } = constants;

class Documents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pageData: [],
            treeData: [],
            pageDataLoading: false,
            treeLoading: false,
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            viewReports: false,
        }

        this.dataCallback = this.dataCallback.bind(this)
        this.setUrlForCategory = this.setUrlForCategory.bind(this)
        this.togglePageLoading = this.togglePageLoading.bind(this);
        this.toggleDataSheetPage = this.toggleDataSheetPage.bind(this);
    }

    async componentDidMount() {
        let catId = 1;
        this.setState({ treeLoading: true });
        axios.get(API_BASE_URL + 'Files/GetDocumentCategories?category=' + catId, { headers: this.state.header })
            .then(result => {
                if (result && result.data) {
                    result.data.forEach((e) => {
                        if (e.nodes && e.nodes.length > 0) {
                            this.setUrlForCategory(e, e.key);
                        }
                        e.url = (API_BASE_URL + 'Files/GetAllDocuments?category=' + e.key + '&root=' + e.key)
                    });
                }
                this.setState({ treeLoading: false, successMessage: 'Success', errorMessage: null, treeData: result.data })
            })
            .catch(error => {
                this.setState({ treeLoading: false, errorMessage: 'Problem loading documents', successMessage: null })
            });
    }

    setUrlForCategory(category, root) {
        if (category.nodes) {
            category.nodes.forEach((e) => {
                this.setUrlForCategory(e, root);
            });
        }
        category.url = (API_BASE_URL + 'Files/GetAllDocuments?category=' + category.url + '&root=' + root);
    }

    dataCallback(data) {
        this.setState({
            pageData: data.data,
            pageDataLoading: false
        });
    }

    togglePageLoading(currentState) {
        this.setState({
            pageDataLoading: currentState
        });
    }

    toggleDataSheetPage(state) {
        this.setState({ viewReports: state })
    }

    render() {
        const { pageData, pageDataLoading, treeData, treeLoading, header } = this.state
        const { dataCallback, togglePageLoading } = this

        return (
            <NPPanel>
                {hasGrant(Grants.TYPES.TDS_SeeSheets) && this.state.viewReports
                    ? <DataSheets toggleDataSheetPage={this.toggleDataSheetPage} apiToken={this.props.apiToken} />
                    : <div>
                        <Row className="d-flex">
                            <Col md={4} lg={3} className="news--treeMenu">
                                {
                                    treeLoading
                                        ? <LoadingSpinner isLoading={true} />
                                        : <NPTreeMenu data={treeData} level0DefaultOpen={true} dataCallback={dataCallback} header={header} toggleContentLoading={togglePageLoading} />
                                }
                            </Col>
                            <Col md={8} lg={7}>
                                {
                                    pageDataLoading
                                        ? <LoadingSpinner isLoading={true} />
                                        : <DocumentsPresentation pageData={pageData} header={header} header={header} />
                                }
                            </Col>
                        </Row>
                        {hasGrant(Grants.TYPES.TDS_SeeSheets)
                            ?
                            <Row>
                                <Col lg={12}>
                                    <Button bsStyle="primary" onClick={() => this.toggleDataSheetPage(true)}>Technical Data Sheets</Button>
                                </Col>
                            </Row>
                            : null
                        }
                    </div>

                }

            </NPPanel>
        );
    }
}

export default Documents;